import {
  List,
  TextField,
  EmailField,
  EditButton,
  FunctionField,
  Filter,
  TextInput,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  ExportButton,
  DatagridConfigurable,
  WrapperField,
  DateField,
  DateInput,
} from "react-admin";
import { IconButton, Button as MUIButton } from "@mui/material";
import { Link } from "react-router-dom";
import { Visibility, QueryStats, UploadFile } from "@mui/icons-material";
import React from "react";
import { SitesEquipmentsImportDialog } from "./SitesEquipmentsImportDialog";

const SiteFilter: React.FC = (props) => (
  <Filter {...props}>
    <TextInput label="Code interne" source="internalCode" alwaysOn />
    <TextInput label="Nom du site" source="name" alwaysOn />
    <TextInput label="Adress" source="address" alwaysOn />
    <TextInput label="Code postal" source="zipCode" alwaysOn />
    <TextInput label="Ville" source="city" alwaysOn />
    <TextInput label="Courriel" source="email" alwaysOn />
    <TextInput label="SIRET" source="siret" alwaysOn />
    <DateInput
      source="startDateCreatedAt"
      label="D. début (création clt)"
      alwaysOn
    />
    <DateInput
      source="endDateLastCreatedAt"
      label="D. fin (création clt)"
      alwaysOn
    />
  </Filter>
);

const ListActions: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  return (
    <TopToolbar>
      <MUIButton
        startIcon={<UploadFile />}
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        Import Excel
      </MUIButton>
      <SitesEquipmentsImportDialog open={open} onClose={() => setOpen(false)} />
      <SelectColumnsButton />
      <CreateButton />
      <ExportButton />
    </TopToolbar>
  );
};

export const SiteList = () => (
  <List
    resource="sites"
    actions={<ListActions />}
    filters={<SiteFilter />}
    title="Liste des sites"
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <DatagridConfigurable
      rowClick={false}
      sx={{
        "& .column-undefined": {
          whiteSpace: "nowrap",
        },
      }}
    >
      <TextField source="internalCode" label="Code interne" />
      <TextField source="name" label="Nom" />
      <TextField source="address" label="Adresse" />
      <TextField source="zipCode" label="Code postal" />
      <TextField source="city" label="Ville" />
      <EmailField source="email" label="Courriel" />
      <TextField source="siret" label="SIRET" />
      <TextField source="contactName" label="Contact" />
      <TextField source="phone" label="Téléphone" />
      <DateField
        source="createdAt"
        textAlign="center"
        label="D. de creation clt"
        locales="fr-FR"
        options={{
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }}
      />
      <WrapperField label="Actions">
        <EditButton />
      </WrapperField>
      <WrapperField
        label="Inventaire"
        headerClassName="inventaire"
        cellClassName="inventaire"
        sortable={false}
      >
        <FunctionField
          render={(record) => (
            <>
              <IconButton
                aria-label="Consulter"
                component={Link}
                to={`/sites/${record.id}/preview`}
                color="primary"
                sx={{ color: "warning.main", mr: 0.5 }}
                onClick={(e) => e.stopPropagation()}
              >
                <Visibility />
              </IconButton>
              <IconButton
                aria-label="Consulter"
                component={Link}
                to={`/sites/${record.id}/stats`}
                color="primary"
                sx={{ color: "secondary.main" }}
                onClick={(e) => e.stopPropagation()}
              >
                <QueryStats />
              </IconButton>
            </>
          )}
        />
      </WrapperField>
    </DatagridConfigurable>
  </List>
);
